import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sun, Moon } from 'lucide-react';
import './styles/sysdesign.css';

const SysDesignLayout = () => {
    // Default to dark mode unless they saved 'light' previously
    const [isDarkMode, setIsDarkMode] = useState(() => {
        if (typeof window !== 'undefined') {
            const saved = localStorage.getItem('sd-theme');
            return saved !== 'light';
        }
        return true;
    });

    useEffect(() => {
        if (typeof window !== 'undefined') {
            localStorage.setItem('sd-theme', isDarkMode ? 'dark' : 'light');
            window.dispatchEvent(new Event('sd-theme-changed'));
        }
    }, [isDarkMode]);

    return (
        <div className={`sysdesign-root ${isDarkMode ? '' : 'sd-light'}`}>
            {/* Floating Theme Toggle */}
            <button
                className="sd-theme-toggle"
                onClick={() => setIsDarkMode(!isDarkMode)}
                aria-label="Toggle theme"
            >
                {isDarkMode ? <Sun size={20} /> : <Moon size={20} />}
            </button>
            <Outlet />
        </div>
    );
};

export default SysDesignLayout;
